<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// import { isMobile } from '@/common/util'
export default {
  name: '',
  components: {
  },
  created () {
    // let isM = isMobile()
    // let path
    // if (isM) {
    //   path = '/m'
    // } else {
    //   path = '/'
    // }
    // // this.$router.push({
    // //   path
    // // })
  }
}
</script>

<style lang="scss">
</style>
